import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, SubmissionError, change, untouch } from "redux-form";
import { compose, withHandlers } from "recompose";
import Button from "react-md/lib/Buttons/Button";

import TextField from "../../components/form/TextField";
import * as Validation from "../../components/form/Validation";

import { updateRequest, getRequestById } from "../../actions/requestActions";
import {DebugElement} from "../../Atollon/debug";
import {TouchVerticalValue_2} from "../../AtollonTheme/ReactElements";
import {FontIcon} from "react-md";
import {FileUploader} from "./FileUploader";
import {concat} from "lodash";
import {RequestDetailInfoAttachments} from "./RequestDetailInfoAttachments";

export const SideBySide = ({ first, second }) =>
{
    return (
        <div className="touchRequestDetail-layout-commentNextToDownloadAndSubmit">
            <div className="touchRequestDetail-layout-commentNextToDownloadAndSubmit-1">
                {first}
            </div>
            <div className="touchRequestDetail-layout-commentNextToDownloadAndSubmit-2">
                {second}
            </div>
            <div style={{clear: "both"}} />
        </div>
    )
};


function log()
{
    console.log.apply( null, concat( ['%cRequestDetailNewComment', 'color:violet;background:black;'], arguments ));
}

export const TouchUploadButton = ({ request, getRequestById }) =>
{
    let fileUploader;

    if( request.recipient.type === 'ORGANIZATION' || request.recipient.type === 'PROJECT' )
    {
        fileUploader = (
            <div>
                <TouchVerticalValue_2
                    title={(
                        <div>
                            <FontIcon className="touchIcon-highligted_onTheLeftSide color-white">link</FontIcon>
                            <span style={{ display: 'inline-block', verticalAlign: 'middle' }}>Přidat přílohu</span>
                        </div>)}
                    value={(
                        <div>
                            {/*
                                                <FileInput
                                                    id="fileInput"
                                                    onChange={() => null}
                                                    accept="image/*"
                                                    name="files"
                                                />
                                                */}
                            <FileUploader requestIdentifier={request.hash} request={request} refresh={()=>{

                            }} getRequestById={getRequestById} />
                        </div>
                    )}
                />

                <div style={{height:'28px'}} />
            </div>
        );
    }
    else
    {
        fileUploader = (<div>Nelze přidat přílohu</div>);
    }

    return fileUploader;
};

const RequestDetailNewComment = ({ handleSubmit, request, user, updateRequest, getRequestById }) => {

  if( request && request.recipient )
  {
      log({ request, 'request.recipient.type': request.recipient.type });
  }

  return (

      <div className="touchRequestDetail-background2 touchBorder-top">
          <div className={"touchRequestDetail-headerPadding"}>


              <div style={{height:'28px'}} />
              <RequestDetailInfoAttachments request={request}/>

              <div style={{height:'28px'}} />

                <form onSubmit={handleSubmit}>
                    <DebugElement text={"src/components/request/RequestDetailNewComment.js"}/>
                    <SideBySide
                        first={(
                            <Field
                                component={TextField}
                                name="comment"
                                label="Komentář"
                                rows={5}
                                validate={[Validation.required]}
                            />
                        )}
                        second={(
                            <div style={{ padding: "0 0 0 10%" }} >
                                <TouchUploadButton request={request} getRequestById={getRequestById} />
                                <div className="">
                                    <Button
                                        flat
                                        className="btn btn-primary touchButton-3"
                                        label="Odeslat"
                                        type="submit"
                                        style={{ display: 'block', width: '100%', margin: 0, paddingRight: '10px', paddingLeft: '10px' }}
                                    />
                                </div>
                            </div>
                        )}
                    />
                    <div style={{height:'28px'}} />
                </form>
          </div>
      </div>
  );
};

export default compose(
  connect(null, { updateRequest, getRequestById }),
  withHandlers({
    onSubmit: () => async (formData, dispatch, props) => {
      const { request, updateRequest, getRequestById } = props;

      if (
        await updateRequest({
          ...request,
          comment: formData.comment
        })
      ) {
          debugger;
        getRequestById(request.hash);
        dispatch(change("newCommentForm", "comment", null));
        dispatch(untouch("newCommentForm", "comment"));
      }
      else
      {
        throw new SubmissionError({
          comment: "Komentář se nepodařilo přidat"
        });
      }
    }
  }),
  reduxForm({ form: "newCommentForm" })
)(RequestDetailNewComment);



// WEBPACK FOOTER //
// ./src/pages/RequestDetail/RequestDetailNewComment.js